<template>
  <div class="w-full">
    <vs-card id="hsbc-loading" class="vs-con-loading__container">
      <vs-row>
        <vs-col>
          <FilePreview
            :name="previewName"
            :expenses="selected"
            @success="clear"
          />
          <expense-detail :expense_id="expense_id" @refresh-table="search" />
          <expense-filter
            :name="filterName"
            @search="search"
            v-model="filter"
          />
          <ExpenseTable
            :data="expenses"
            :clients="clients"
            v-model="selected"
            :client="params.client"
            @updateClient="updateClient"
            @search="search"
            @preview="preview"
            @openFilter="openFilter"
            @openDetail="openDetail"
            @loadMore="loadMore"
            @sort="sort"
          />
        </vs-col>
      </vs-row>
    </vs-card>
  </div>
</template>

<script>
import ExpenseTable from './components/ExpenseTable.vue'
import FilePreview from './components/FilePreview.vue'
import ExpenseFilter from './components/ExpenseFilter.vue'
import ExpenseDetail from '@/views/apps/accounting/components/ExpenseDetail.vue'
import vSelect from 'vue-select'
import request from './request.js'
import loading from '@/mixins/Loading'
export default {
  components: {
    vSelect,
    ExpenseTable,
    ExpenseFilter,
    ExpenseDetail,
    FilePreview,
  },
  mixins: [loading],
  data() {
    return {
      filterName: 'hsbc-expense-filter',
      previewName: 'hsbc-file-preview',
      expense_id: '',
      expenses: [],
      clients: [],
      selected: [],
      filter: {
        vendors: [],
        companies: [],
        periods: [],
        categories: [],
        currencies: [],
        date: '',
      },
      params: {
        client: '',
        search: '',
        page: 1,
        sort: ['ASC'],
        sortBy: ['client.ClientName'],
      },
      lastPage: 1,
      loading: {
        data: false,
        clients: false,
      },
    }
  },
  computed: {
    isLoading() {
      return this.loading.clients || this.loading.data
    },
  },
  methods: {
    getData() {
      this.loading.data = true

      let data = {
        vendors: this.filter.vendors.map(el => el.id),
        companies: this.filter.companies,
        periods: this.filter.periods,
        categories: this.filter.categories,
        currencies: this.filter.currencies,
        date: this.filter.date,
        search: this.params.search,
        client: this.params.client,
        page: this.params.page,
      }

      request
        .getExpenses(data)
        .then((response) => {
          this.loading.data = false
          if (this.params.page === 1) {
            this.expenses = [...response.data.data]
          } else {
            this.expenses = [...this.expenses, ...response.data.data]
          }
          this.lastPage = response.data.last_page
        })
        .catch((response) => {
          this.loading.data = false
          this.$vs.notify({
            color: 'danger',
            title: 'Attention',
            text: 'Server Error',
          })
        })
    },
    loadMore() {
      if (this.params.page >= this.params.lastPage) {
        return
      }
      this.params.page++
      this.getData()
    },
    search(text = '') {
      this.params.search = text
      this.params.page = 1
      this.getData()
    },
    openFilter() {
      this.$store.dispatch('toggleSidebar', this.filterName)
    },
    openDetail(expense_id) {
      this.expense_id = expense_id
      this.$store.dispatch('toggleSidebar', 'expense-detail')
    },
    getClients() {
      this.loading.clients = true
      request
        .getClients()
        .then((response) => {
          this.clients = [...response.data.clients]
          this.loading.clients = false
        })
        .catch((response) => {
          this.loading.clients = false
          this.$vs.notify({
            color: 'danger',
            title: 'Attention',
            text: 'Server Error',
          })
        })
    },
    updateClient(id) {
      this.params.client = id
      this.params.page = 1
      this.getData()
    },
    sort(e){
      this.params.sort=e.sort
      this.params.sortBy=e.sortBy
      this.search()
    },
    preview() {
      this.$store.dispatch('toggleSidebar', this.previewName)
    },
    clear() {
      this.selected = []
      this.search(this.params.search)
    },
  },
  mounted() {
    this.getClients()
  },
  watch: {
    isLoading(val) {
      if (val) {
        this.openLoading('hsbc-loading')
      } else {
        this.closeLoading('hsbc-loading')
      }
    },
  },
}
</script>

<style>
</style>
